<template>
    <div id="overlay">
        <div id="text" class="border">
            <div id="overlayHeader">
                <h2>Synthèse</h2>
            </div>
            <span id="cancel">
                <b-icon v-on:click="toggleOverlay" icon="x-circle-fill" />
            </span>

            <DataTable :header-fields="headerFields" :sort-field="sortField" :sort="sort" :data="data || []" track-by="name" :css="datatableCss" not-found-msg="Pas de saisie ce mois-ci" @on-update="dtUpdateSort">
                <Pagination slot="pagination" :page="currentPage" :total-items="totalItems" :items-per-page="itemsPerPage" :css="paginationCss" @on-update="changePage" @update-current-page="updateCurrentPage" />
            </DataTable>

        </div>
    </div>
</template>

<script>
    var orderBy = require('lodash/orderBy');

    import {
        DataTable,
        Pagination
    } from 'v-datatable-light'

    export default {
        name: "StatsOverlay",
        components: {
            DataTable,
            Pagination
        },
        props: ['events', 'overlay'],
        data() {
            return {
                projects: [],
                data: [],
                headerFields: [{
                        name: "name",
                        label: "Projet",
                        sortable: true
                    },
                    {
                        name: "client",
                        label: "Client",
                        sortable: true
                    },
                    {
                        name: "time",
                        label: "Temps",
                        sortable: true
                    },
                    {
                        name: "comment",
                        label: "Commentaire",
                        sortable: true
                    }
                ],
                sort: "asc",
                sortField: "name",
                currentPage: 1,
                itemsPerPage: 10,
                totalItems: 16,
                datatableCss: {
                    table: "table table-bordered table-hover table-striped table-center",
                    theadTh: "header-item",
                    tbodyTd: "tdBody",
                    thWrapperCheckboxes: "th-wrapper checkboxes",
                    footer: "footer"
                },
                paginationCss: {
                    paginationItem: "pagination-item",
                    moveFirstPage: "move-first-page",
                    movePreviousPage: "move-previous-page",
                    moveNextPage: "move-next-page",
                    moveLastPage: "move-last-page",
                    pageBtn: "page-btn"
                },
            }
        },
        mounted: function() {
            this.data = this.projects.slice(0, 10);
        },
        methods: {
            toggleOverlay: function() {
                this.$emit('close');
            },
            concatComment: function(index, event) {
                if (event.comment) {
                    if (this.projects[index].comment) {
                        this.projects[index].comment = this.projects[index].comment.concat(', ', event.comment);
                    } else {
                        this.projects[index].comment = event.comment;
                    }
                }
            },
            calculTime: function(index, event) {
                var tmp = this.projects[index].time;
                var total = tmp.split(' ');

                total[0] = total[0].replace('j', '');
                total[1] = total[1].replace('h', '');
                total[2] = total[2].replace('m', '');

                var eventTime = event.duration.split(':');

                var day = Number(total[0]);
                var minutes = Number(total[2]) + Number(eventTime[1]);
                var hours = Number(total[1]) + Number(eventTime[0]);

                if (minutes >= 60) {
                    hours++;
                    minutes -= 60;
                }

                if (hours >= 7) { // suppose a day is 7 hours
                    day++;
                    hours -= 7;
                }

                if (hours < 10) {
                    hours = '0' + hours;
                }
                if (minutes < 10) {
                    minutes = '0' + minutes;
                }
                this.projects[index].time = day + 'j ' + hours + 'h ' + minutes + 'm';

            },

            dtUpdateSort: function({
                sortField,
                sort
            }) {
                const sortedData = orderBy(this.projects, [sortField], [sort]);
                const start = (this.currentPage - 1) * this.itemsPerPage;
                const end = this.currentPage * this.itemsPerPage;
                this.data = sortedData.slice(start, end);
            },
            changePage: function(currentPage) {
                this.currentPage = currentPage;
                const start = (currentPage - 1) * this.itemsPerPage;
                const end = currentPage * this.itemsPerPage;
                this.data = this.projects.slice(start, end);
            },

            updateCurrentPage: function(currentPage) {
                this.currentPage = currentPage;
            }
        },
        watch: {
            events: function() {
                this.total = [];
                this.projects = [];
                this.events.forEach(eventPerDay => {
                    eventPerDay.forEach(event => {
                        var index = this.projects.findIndex(proj => proj.name == event.project_name);
                        if (index < 0) {
                            index = this.projects.push({
                                name: event.project_name,
                                client: event.client_name,
                                time: '0j 0h 0m',
                                comment: event.comment,
                            }) - 1;
                        } else {
                            this.concatComment(index, event)
                        }
                        this.calculTime(index, event);
                    });

                });
                this.totalItems = this.projects.length;
                this.data = this.projects.slice(0, 10);
            },
        },
    };
</script>

<style scoped>
    #overlay {
        position: fixed;
        display: block;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 2;
    }

    #text {
        width: auto;
        position: absolute;
        padding: 1em;
        top: 50%;
        left: 50%;
        color: white;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        background-color: white;
        border-radius: 25px;
        min-width: 100px;
    }

    h2 {
        background-color: white;
        color: black;
        width: 80%;
        margin: auto;
    }

    #table {
        width: 100%;
        position: relative;
    }

    #cancel {
        position: absolute;
        top: 0px;
        right: 5px;
        color: red;
        font-size: 30px;
    }

    #cancel:hover {
        cursor: pointer;
    }

    #noLog {
        color: black;
        font-size: 16px;
    }

    .projets {
        text-align: left;
    }

    .time {
        text-align: right;
    }

    .test {
        white-space: nowrap;
    }
</style>

<style>
    /* Datatable CSS */
    .v-datatable-light .header-item {
        cursor: pointer;
        color: #337ab7;
        transition: color 0.15s ease-in-out;
    }

    .v-datatable-light .header-item:hover {
        color: #ed9b19;
    }

    .v-datatable-light .header-item.no-sortable {
        cursor: default;
    }

    .v-datatable-light .header-item.no-sortable:hover {
        color: #337ab7;
    }

    .v-datatable-light .header-item .th-wrapper {
        display: flex;
        width: 100%;
        height: 100%;
        font-weight: bold;
    }

    .v-datatable-light .header-item .th-wrapper.checkboxes {
        justify-content: center;
    }

    .v-datatable-light .header-item .th-wrapper .arrows-wrapper {
        display: flex;
        flex-direction: column;
        margin-left: 10px;
        justify-content: space-between;
    }

    .v-datatable-light .header-item .th-wrapper .arrows-wrapper.centralized {
        justify-content: center;
    }

    .v-datatable-light .arrow {
        transition: color 0.15s ease-in-out;
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
    }

    .v-datatable-light .arrow.up {
        border-bottom: 8px solid #337ab7;
    }

    .v-datatable-light .arrow.up:hover {
        border-bottom: 8px solid #ed9b19;
    }

    .v-datatable-light .arrow.down {
        border-top: 8px solid #337ab7;
    }

    .v-datatable-light .arrow.down:hover {
        border-top: 8px solid #ed9b19;
    }

    .v-datatable-light .footer {
        display: flex;
        justify-content: space-between;
    }

    .v-datatable-light .tdBody {
        white-space: nowrap;
    }

    .v-datatable-light .column-3 { 
        white-space: normal;
    }

    .v-datatable-light-pagination {
        list-style: none;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 0;
        height: 30px;
        margin: auto;
    }

    .v-datatable-light-pagination .pagination-item {
        width: 30px;
        margin-right: 5px;
        font-size: 16px;
        transition: color 0.15s ease-in-out;
    }

    .v-datatable-light-pagination .pagination-item.selected {
        color: #ed9b19;
    }

    .v-datatable-light-pagination .pagination-item .page-btn {
        background-color: transparent;
        outline: none;
        border: none;
        color: #337ab7;
        transition: color 0.15s ease-in-out;
    }

    .v-datatable-light-pagination .pagination-item .page-btn:hover {
        color: #ed9b19;
    }

    .v-datatable-light-pagination .pagination-item .page-btn:disabled {
        cursor: not-allowed;
        box-shadow: none;
        opacity: .65;
    }
    
    @media screen and (max-width: 479px){
      .border {
        width: 73% !important;
      }
      #text {
        left: 39.5%;
      }
    }
</style>